// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/**\n  * Mew Input styles\n  */\n.mew-input .mdi-close {\n  font-size: 20px !important;\n}\n.mew-input.v-input--is-focused .mdi-close {\n  color: var(--v-titlePrimary-base) !important;\n}\n.mew-input .v-text-field__slot .v-label {\n  margin-top: 5px;\n}\n.mew-input .v-text-field__slot .v-label--active {\n  margin-top: 0;\n}\n.mew-input .v-input__icon--append .mdi {\n  color: var(--v-disabled-base);\n}", ""]);
// Exports
module.exports = exports;
